var map = {
	"./assetSummary.png": 2850,
	"./barChart.png": 2851,
	"./battery.png": 2852,
	"./batteryExchange.png": 2853,
	"./batteryLevel.png": 2854,
	"./cages.png": 2855,
	"./deployment.png": 2856,
	"./distribution.png": 2857,
	"./favouriteAssets.png": 2858,
	"./favouritePeople.png": 2859,
	"./favouriteZone.png": 2860,
	"./floorplan.png": 2861,
	"./guage.png": 2862,
	"./hours.png": 2863,
	"./lifecycle.png": 2864,
	"./lineChart.png": 2865,
	"./map.png": 2866,
	"./peopleSummary.png": 2867,
	"./recentItem.png": 2868,
	"./zoneSummary.png": 2869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 622;